import React from 'react';
import { makeStyles } from "../../styles/index";
var styles = function () { return ({
    root: {
        flexGrow: 1,
    },
}); };
var useStyles = makeStyles(styles, { name: 'SnSpacer' });
export var Spacer = function () {
    var classes = useStyles();
    return React.createElement("div", { className: classes.root });
};
